export const TimeStampRegExp = {
  'h:mm:ss:ff': /^(2[0-3]|[01][0-9]|[0-9]):[0-5][0-9]:[0-5][0-9]:[0-2][0-9]$/,
  'mm:ss:ff': /^[0-5][0-9]:[0-5][0-9]:[0-2][0-9]$/,
  'ss:ff': /^[0-5][0-9]:[0-2][0-9]$/,
};
